import { HotTakesSummaryCard } from "@/components/shared/hot-takes-summary-card";
import {
  normalizeHotTakesShapes,
  type TeenHotTakesConfig,
  type TeenHotTakesResult,
} from "@/lib/activities/hot-takes-shapes";
import type { ActivityResultCardProps } from "@/lib/activities/registry";
import type {
  HotTakeAnswer,
  HotTakesConfig,
  HotTakesResult,
} from "@somethings-ui/core/hot-takes";

export function HotTakesResultCard({
  participants,
  result,
  config,
  onClick,
}: ActivityResultCardProps<
  HotTakesConfig | TeenHotTakesConfig,
  HotTakesResult | TeenHotTakesResult
>) {
  const { statements, responses } = normalizeHotTakesShapes(config, result);
  const matchesCount = result.matchesCount ?? 0;

  const teenAnswerById = new Map<string, HotTakeAnswer>(
    responses.map((r) => [r.statementId, r.teenAnswer]),
  );

  return (
    <HotTakesSummaryCard
      mentorName={participants.mentor.name}
      teenName={participants.teen.name ?? ""}
      matchesCount={matchesCount}
      mentorAvatarUrl={participants.mentor.avatarUrl}
      teenAvatarUrl={participants.teen.avatarUrl}
      statements={statements}
      teenAnswerById={teenAnswerById}
      onClick={onClick}
    />
  );
}
